
import CryptoJS from 'crypto-js';


export const truncateText = (text, charLimit) => {
    if (!text) return '';
    return text.length > charLimit ? text.slice(0, charLimit) + '...' : text;
};

export const changeDateFormat = (dateString, splitForment) => {
    if (!dateString || !String(dateString).trim()) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}${splitForment || "/"}${month}${splitForment || "/"}${year}`;
};

export const changeTimeFormat = (dateString = new Date(), splitFormat = ":", useAmPm = false) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    if (useAmPm) {
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours === 0 ? 12 : hours;
        return `${String(hours).padStart(2, '0')}${splitFormat}${minutes} ${ampm}`;
    }
    return `${String(hours).padStart(2, '0')}${splitFormat}${minutes}`;
};

export const transformButtons = (buttons) => {
    return buttons.map(button => {
        switch (button.value) {
            case "URL":
                return {
                    type: "URL",
                    text: button.btnText,
                    url: button.text
                };
            case "QUICK_REPLY":
                return {
                    type: "QUICK_REPLY",
                    text: button.btnText
                };
            case "PHONE_NUMBER":
                return {
                    type: "PHONE_NUMBER",
                    text: button.btnText,
                    phone_number: button.text
                };
            default:
                return null;
        }
    }).filter(Boolean);
};

export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export function convertHtmlToMarkdown(html) {
    // Replace <b> and </b> with * for bold
    let markdown = html.replace(/<b>(.*?)<\/b>/g, '*$1*');
    // Replace <i> and </i> with _ for italic and trim spaces
    markdown = markdown.replace(/<i.*?>(.*?)<\/i>/g, '_$1_');
    // Replace <span> (with style) and get only the text content
    markdown = markdown.replace(/<span[^>]*>(.*?)<\/span>/g, '$1');
    // Replace &nbsp; with space
    markdown = markdown.replace(/&nbsp;/g, ' ');
    // Replace <br> or <br /> with new line (\n)
    markdown = markdown.replace(/<br\s*\/?>/g, '\n');
    // Replace <div> with new line (\n) and trim spaces
    markdown = markdown.replace(/<div>/g, '\n').replace(/<\/div>/g, '');
    // Trim spaces around italic text and other characters
    markdown = markdown.replace(/_+\s+/g, '_'); // Remove spaces after _
    markdown = markdown.replace(/\s+_+/g, '_'); // Remove spaces before _
    // Handle any other spaces around the content
    markdown = markdown.replace(/\s+/g, ' ').trim(); // Remove extra spaces
    return markdown;
}

export function convertMarkdownToHtml(markdown) {
    // Replace * for bold with <b> and </b>
    let html = markdown.replace(/\*(.*?)\*/g, '<b>$1</b>');
    // Replace _ for italic with <i> and </i>
    html = html.replace(/_(.*?)_/g, '<i>$1</i>');
    // Replace new line (\n) with <br />
    html = html.replace(/\n/g, '<br />');
    return html;
}

export const TextColorCode = (status) => {
    switch (status) {
        case "All":
            return "#F93E3E";
        case "New":
            return "#4164E3";
        case "Rejected":
            return "#D74A3A";
        case "Deleted":
            return "#D74A3A";
        case "Verified":
            return "#34A853";
        case "Pending":
            return "#FF9900";
        case "Update":
            return "#9747FF";
        case "Blacklisted":
            return "#D74A3A";
        case "Disabled":
            return "#D74A3A";
        case "Active":
            return "#34A853";
        case "running":
            return "#34A853";
        case "draft":
            return "#4164E3";
        case "stopped":
            return "#F93E3E";
        case "Delete":
            return "#D74A3A";
        default:
            return "#c2c2c2";
    }
};

export const customDebounce = (func, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
};

export const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
};

export const CryptoEncrypt = (value) => {
    const stringValue = String(value);
    return CryptoJS.AES.encrypt(stringValue, "secret key").toString();
};
export const CryptoDecrypt = (value) => {
    const bytes = CryptoJS.AES.decrypt(value, "secret key");
    return bytes.toString(CryptoJS.enc.Utf8);
};


